import * as types from '../mutation-types';
import Vue from 'vue';
import {forEach} from "lodash";

// state
export const state = [];

// mutations
export const mutations = {
  [types.FETCH_TAGS_FAILURE](state) {
  },

  [types.FETCHING_TAGS](state) {
  },

  [types.FETCH_TAGS_SUCCESS](state, tags) {
    state.splice(0, state.length, ...tags);
  },

  [types.RESET_TAGS](state) {
    state.length = 0;
  },
};

// actions
export const actions = {

  /**
   * @param commit
   * @param {boolean} includeInactive - Whether to include inactive tags
   * @returns {Promise<void>}
   */
  async refreshTags({ commit }, { includeInactive = false } = {}) {
    commit(types.FETCHING_TAGS);
    try {
      const response = await Vue.$model.getTags({ includeInactive });
      commit(types.FETCH_TAGS_SUCCESS, response.data.data);
    } catch (e) {
      commit(types.FETCH_TAGS_FAILURE);
    }
  },

  resetTags({ commit }) {
    commit(types.RESET_TAGS);
  },
};

// getters
export const getters = {
  tags: state => state,
  optionTags: state => {
    if (state.length > 0) {
      return state.map(tag => tag.tag);
    }
    return [];
  },
};
